import { Component, OnInit, ViewChild, ElementRef, OnDestroy, HostListener } from '@angular/core';
import { locale, loadMessages } from 'devextreme/localization';
import deMessages from 'devextreme/localization/messages/de.json';
import * as deLocale from 'date-fns/locale/de/index.js';
import { ReservationService } from '../reservation.service';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { DxSchedulerComponent } from 'devextreme-angular/ui/scheduler';
import { DxContextMenuComponent } from 'devextreme-angular/ui/context-menu';
// import * as events from 'devextreme/events';
import moment from 'moment';
moment.locale('de');
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { differenceInMinutes, subDays, addDays, isSameDay } from 'date-fns';
import { Page, Reservation } from '../reservation.model';
import { AddReservationComponent } from './add-reservation/add-reservation.component';
import { MatSnackBar, MatBottomSheet, MatBottomSheetRef } from '@angular/material';
import { AuthenticationService, Constants, CredentialsService, resStatus } from '@app/core';
import { ConfirmModalComponent } from '@app/shared/confirm-modal/confirm-modal.component';
import * as screenfull from 'screenfull';
import { Screenfull } from 'screenfull';
import 'rxjs/add/operator/map';
import { SocketService } from '@app/socket.service';
import { Subscription, Subject } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BreakpointState, BreakpointObserver } from '@angular/cdk/layout';
import { NavService } from '@app/nav.service';
import 'rxjs/add/operator/takeUntil';
import { PendingReservationsComponent } from './pending-reservations/pending-reservations.component';
import { ActivatedRoute } from '@angular/router';
import { BVAddReservationComponent } from './bv-add-reservation/bv-add-reservation.component';
import { ThemeService } from '@app/shell/theme.service';
import { ReservationPdfSettings } from '../reservation-settings/reservation-settings.model';
import { UtilService } from '@app/core/util.service';
declare const require: any;
const jsPDF = require('jspdf');
require('jspdf-autotable');
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-reservations',
  templateUrl: './reservations.component.html',
  styleUrls: ['./reservations.component.scss']
})
export class ReservationsComponent implements OnInit, OnDestroy {
  bookSettings: any;
  dateOptions = {
    locale: deLocale
  };
  todayDate: Date = new Date();
  dataSource: any = {};
  priorityData: [];
  typeData: [];
  tablesData: any = [];
  rooms: any = [];
  shifts: any = [];
  temp: any = [];
  currentDate: Date = new Date();
  pendingCounter = 0;
  waitingCounter = 0;
  reservations: any = [];
  tags: any = [];
  allTags: any = [];
  resAddOns: any[] = [];
  filteredReservations: any[] = [];
  resetTimeFilter = false;
  resStatusList: any[] = [];
  allStatus: any[] = resStatus;
  isFullscreen = false;
  view: String = 'list';
  page: Page = new Page();
  editing: any = {};
  columns = [{ name: 'Uhrzeit' }, { name: 'Gast' }, { name: 'Personen' }, { name: 'Tisch' }, { name: 'Status' }];
  isDoubleClick = 0;
  prevCellData: any = null;
  alerts: any;
  resMenuOrderAlert: any = [];
  activeClient: any;
  reloadInterval: any;
  filter: any = {
    name: '',
    status: null,
    tags: [],
    roomId: [],
    shiftId: null
  };
  selectedRoomId: number;
  schedulerHeight: any = '';
  listHeight = 'initial';
  loadingReservationList: boolean;
  // timeFilter = [
  //   { name: 'Morgen', from: '07:00', to: '11:00' },
  //   { name: 'Mittag', from: '11:00', to: '16:00' },
  //   { name: 'Abend', from: '16:00', to: '24:00' }
  // ];
  timeFilter: any = [];
  selectedTimeFilter: any = [];
  tempRes: any = [];
  showExtraFilters: boolean = false;
  pdfSetting: ReservationPdfSettings = {
    showTags: true,
    showGuestNotes: false,
    showAdminNotes: false,
    showRoomNumber: false,
    showArrivingDate: false,
    showDepartureDate: false,
    showBoard: false,
    showEndTime: false
  };
  @ViewChild(DxSchedulerComponent, { static: false }) scheduler: DxSchedulerComponent;
  @ViewChild('cellMenu', { static: false }) cellMenu: DxContextMenuComponent;
  @ViewChild('reservationMenu', { static: false }) reservationMenu: DxContextMenuComponent;
  @ViewChild('fullscreenEl', { static: false }) fullscreenEl: ElementRef;
  @ViewChild('buttonBar', { static: false }) buttonBar: ElementRef;
  @ViewChild('roomTabsGroup', { static: false }) roomTabsGroup: any;

  // Context Menu
  contextMenuCellData: any;
  contextMenuAppointmentData: any;
  contextMenuTargetedAppointmentData: any;
  reservationContextMenuItems: any = [];
  cellContextMenuItems: any;
  selectedCellData: any;
  activeClientSettings: any;

  // Edit mode(for mobile touch drag)
  editMode = false;

  // Fake fullscreen
  isFakeFullscreen = false;

  // Layout
  readonly LAYOUT = {
    XXS: 450,
    XS: 768,
    SM: 992,
    MD: 1200,
    LG: 1600,
    XL: 1920,
    XXL: 2560
  };
  layout: number = this.LAYOUT.MD;

  // Sockets
  private _reservationSub: Subscription;
  private _reservationUpdateSub: Subscription;
  private _reservationFileUploadeSub: Subscription;

  private ngUnsubscribe: Subject<any> = new Subject();
  isArchive: boolean = false;
  resId: any;
  reservationListActive: boolean = false;
  activeTheme: string;
  creds: any;

  // Timeline room tab index (bound to mat-tab-group via [selectedIndex]="tab")
  tab = 0;
  // Timeline sidebar open state. Defaults to open so the reservation cards
  // are immediately visible; users can hide it to give the scheduler more room.
  timelineSidebarOpen = true;
  // Full-page loader flag — true while the timeline dataSource is fetching.
  // Shown as an overlay covering the whole timeline view (not just the
  // dx-scheduler's built-in loader).
  loadingTimeline = false;
  sidebarStatusItems: any[] = [
    { text: 'Ausstehend', color: '#9f9f9f', value: 'pending', isActive: false },
    { text: 'Bestätigt', color: '#24b314', value: 'confirmed', isActive: false },
    { text: 'Angekommen', color: '#ebb12b', value: 'arrived', isActive: false },
    { text: 'No-Show', color: '#912f5e', value: 'noShow', isActive: false },
    { text: 'Storniert', color: '#e65252', value: 'canceled', isActive: false },
    { text: 'Platziert', color: '#1371fe', value: 'placed', isActive: false },
    { text: 'Fertig', color: '#495057', value: 'finished', isActive: false }
  ];

  mealOptions: { value: string; label: string; color: string }[] = [
    { value: 'FR', label: this.translate.instant('HotelReservations.Breakfast'), color: 'lightsalmon' },
    { value: 'HP', label: this.translate.instant('HotelReservations.HalfBoard'), color: 'lightpink' },
    { value: 'VP', label: this.translate.instant('HotelReservations.FullBoard'), color: 'lightblue' }
  ];

  allGastOptions: { label: string; value: string | null; group: string | null; color: string | null }[] = [];

  hotelIntegration: boolean = false;

  constructor(
    private snackBar: MatSnackBar,
    private reservationService: ReservationService,
    private modalService: NgbModal,
    private authService: AuthenticationService,
    private socketService: SocketService,
    private deviceService: DeviceDetectorService,
    private breakpointObserver: BreakpointObserver,
    private navService: NavService,
    private bottomSheet: MatBottomSheet,
    private credentialsService: CredentialsService,
    private route: ActivatedRoute,
    private themeService: ThemeService,
    private utilsService: UtilService,
    public translate: TranslateService
  ) {
    this.creds = this.credentialsService && this.credentialsService.credentials;

    loadMessages(deMessages);
    locale('de');
    this.themeService.activeTheme$.subscribe((theme: any) => {
      this.activeTheme = theme;
    });

    this.reservationService
      .getReservationBookSettings()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((settings: any) => {
        this.bookSettings = settings;
        if (this.bookSettings && Object.keys(this.bookSettings).length > 0) {
          this.bookSettings.startTimeOriginal = this.bookSettings.startTime;
          this.bookSettings.endTimeOriginal = this.bookSettings.endTime;
        }
      });

    this.resId = this.route.snapshot && this.route.snapshot.params ? this.route.snapshot.params.reservationId : '';
    this.page.pageNumber = 0;
    this.page.size = 20;

    // Create context menu
    this.cellContextMenuItems = [
      {
        text: 'Neue Reservierung',
        onItemClick: (e: any) =>
          this.addReservation(
            false,
            this.contextMenuCellData.startDate,
            this.contextMenuCellData.endDate,
            this.contextMenuCellData.groups.tableId
          )
      },
      {
        text: 'Neuer Walk-In',
        onItemClick: () =>
          this.addReservation(
            true,
            this.contextMenuCellData.startDate,
            this.contextMenuCellData.endDate,
            this.contextMenuCellData.groups.tableId,
            true
          )
      }
    ];

    /*
    (screenfull as Screenfull).on('change', () => {
      if ((screenfull as Screenfull).isFullscreen) {
        console.log('fullscreen');
        this.isFullscreen = true;
        // Set height of scheduler to fit window height and make inner table scrollable
        if (this.view === 'timeline') {
          setTimeout(() => {
            // Set scheduler height
            this.schedulerHeight =
              this.fullscreenEl.nativeElement.offsetHeight -
              (this.roomTabsGroup._elementRef.nativeElement.offsetHeight +
                this.buttonBar.nativeElement.offsetHeight -
                10);
            this.scheduler.instance.repaint();
          }, 200);
        } else {
          // Set list height
          setTimeout(() => {
            this.listHeight = window.outerHeight - this.buttonBar.nativeElement.offsetHeight + 'px';
            this.table.recalculate();
          }, 200);
        }
      } else {
        this.isFullscreen = false;
        this.schedulerHeight = '';
        if (this.scheduler) {
          this.scheduler.instance.repaint();
        }
      }
    });
    */
  }

  async ngOnInit() {
    this.allGastOptions = [
      { label: 'Alle', value: null, group: null, color: null },
      { label: 'Externe Gäste', value: 'external', group: null, color: null },
      { label: 'Alle Hotelgäste', value: 'hotel_all', group: 'Hotelgäste', color: null },
      ...this.mealOptions.map(meal => ({
        label: meal.label,
        value: meal.value,
        group: 'Hotelgäste',
        color: meal.color
      }))
    ];
    this.reservationService.getPMSDetails().subscribe(res => {
      if (res && res.length) {
        this.hotelIntegration = true;
      }
    });

    if (this.resId) {
      this.currentDate = await this.reservationService
        .getDateofReservation(this.resId)
        .toPromise()
        .then((data: any) => {
          this.currentDate = new Date(data.reservedFor);
          return new Date(data.reservedFor);
        });
    }
    this.route.queryParams.subscribe(params => {
      if (params['date']) {
        this.currentDate = new Date(params['date']); // or use parseISO(params['date']) for stricter parsing
      }

      this.changeDate(); // initialize view
    });

    this.authService
      .getActiveClient()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((clientData: any) => {
        this.activeClient = clientData;
        // (<any>window).ga(
        //   'set',
        //   'title',
        //   'Reservierungsbuch - ' + this.activeClient.name + ' ' + this.activeClient.location
        // );
        // this.socketService.joinClient(this.activeClient.id);
      });
    this.getResTimeFilter();
    this.getRooms();
    this.getShifts();
    this.getAllTags();
    this.getAlerts();
    this.reservationService.getReservationAddOnTemplates().subscribe(resAddOns => {
      this.resAddOns = resAddOns;
    });
    this.getAllReservations();
    // below code is for PDF
    // fetching all settings required for pdf generation
    this.reservationService
      .getReservationPdfSettings()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((pdfsettings: any) => {
        this.pdfSetting = pdfsettings;
      });
    this.reservationService
      .getSettingsOfClient(+this.route.snapshot.params.clientId)
      .takeUntil(this.ngUnsubscribe)
      .subscribe((lang: any) => {
        this.activeClientSettings = lang.defaultLang ? lang.defaultLang : 'de';
      });

    // end of PDF code

    document.addEventListener('fullscreenchange', e => {
      if (document && document['fullscreenElement']) {
        this.isFullscreen = true;
        // Set height of scheduler to fit window height and make inner table scrollable
        if (this.view === 'timeline') {
          setTimeout(() => {
            // Set scheduler height
            this.schedulerHeight =
              window.innerHeight -
              (this.roomTabsGroup._elementRef.nativeElement.offsetHeight +
                this.buttonBar.nativeElement.offsetHeight -
                10);
            setTimeout(() => {
              this.scheduler.instance.repaint();
            }, 100);
          }, 200);
        } else {
          // Set list height
          setTimeout(() => {
            this.listHeight = window.innerHeight + 'px';
            // this.table.recalculate();
          }, 200);
        }
      } else {
        this.isFullscreen = false;
        this.schedulerHeight = '';
        if (this.scheduler) {
          this.scheduler.instance.repaint();
        }
      }
    });

    // Get socket messages
    this._reservationSub = this.socketService.newReservation.takeUntil(this.ngUnsubscribe).subscribe((res: any) => {
      // Check if reservation is from current day in view
      // if (moment(this.currentDate).isSameOrAfter(res.reservedFor, 'day')) {
      if (
        moment().isSame(res.reservedFor, 'day') ||
        (this.creds && Number(this.creds.id) === Number(res.updatedByUser))
      ) {
        this.snackBar.open('Neue Reservierung eingetroffen', '', {
          duration: 2000,
          panelClass: ['snackbar-info']
        });
        if (this.view === 'list') {
          this.getAllReservations();
        } else {
          this.dataSource.reload();
        }
      }
    });

    this._reservationUpdateSub = this.socketService.updateReservation
      .takeUntil(this.ngUnsubscribe)
      .subscribe(async (res: any) => {
        // Check if reservation is from current day in view
        // if (moment(this.currentDate).isSameOrAfter(res.reservedFor, 'day')) {
        if (
          moment().isSame(res.reservedFor, 'day') ||
          (this.creds && Number(this.creds.id) === Number(res.updatedByUser))
        ) {
          let snackMsg = '';
          if (res.guestData) {
            snackMsg = 'Reservierung von ' + res.guestData.name + ' wurde aktualisiert';
          } else {
            snackMsg = 'Walk-In um ' + moment(res.reservedFor).format('HH:mm') + ' Uhr wurde aktualisiert';
          }
          this.snackBar.open(snackMsg, '', {
            duration: 2000,
            panelClass: ['snackbar-info']
          });
          if (this.view === 'list') {
            if (!res.calledFunction || res.calledFunction != 'change-status') {
              this.getAllReservations();
            } else {
              await new Promise<void>(resolve => {
                this.setReservationListValues();
                resolve();
              });
            }
          } else {
            this.dataSource.reload();
          }
        }
      });

    this._reservationFileUploadeSub = this.socketService.uploadFiles
      .takeUntil(this.ngUnsubscribe)
      .subscribe((res: any) => {
        // Check if reservation is from current day in view
        // if (moment(this.currentDate).isSameOrAfter(res.reservedFor, 'day')) {
        if (
          moment().isSame(res.reservedFor, 'day') ||
          (this.creds && Number(this.creds.id) === Number(res.updatedByUser))
        ) {
          if (this.view === 'list') {
            this.getAllReservations();
          } else {
            this.dataSource.reload();
          }
        }
      });

    // Setting up breakpoint mechanism
    const breakpoints = Object.keys(this.LAYOUT).map(k => this.LAYOUT[k]);
    breakpoints.forEach((maxWidth, index) => {
      const minWidth = index > 0 ? breakpoints[index - 1] : 0;
      this.breakpointObserver
        .observe([`(min-width: ${minWidth}px) and (max-width: ${maxWidth - 1}px)`])
        .takeUntil(this.ngUnsubscribe)
        .subscribe((state: BreakpointState) => {
          if (!state.matches) {
            return;
          }
          this.layout = maxWidth;
        });
    });
    this.getAllStatus();
  }

  ngOnDestroy(): any {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this._reservationSub.unsubscribe();
    this._reservationFileUploadeSub.unsubscribe();
    // Avoid leaving the timeline-loading body class attached if we unmount
    // while a fetch is in-flight.
    if (typeof document !== 'undefined' && document.body) {
      document.body.classList.remove('timeline-loading');
    }
  }

  getAllStatus() {
    this.reservationService
      .getResStatus()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((resStatusList: any) => {
        this.resStatusList = resStatusList;
        this.resStatusList.forEach((item: any) => {
          item['type'] = 'single';
        });
        this.allStatus = this.allStatus.concat(this.resStatusList);
      });
  }

  getAlerts() {
    return this.reservationService
      .getAlerts('staff', moment(this.currentDate).format('YYYY-MM-DD'))
      .takeUntil(this.ngUnsubscribe)
      .subscribe((alerts: any) => {
        this.alerts = alerts;
      });
  }

  closeAlert(alert: any) {
    this.alerts.splice(this.alerts.indexOf(alert), 1);
  }

  closeResMenuOrderAlert(alert: any) {
    this.resMenuOrderAlert.splice(this.alerts.indexOf(alert), 1);
  }

  changeView(val: string) {
    if (val === 'list') {
      if (this.listHeight === '') {
        // Set list height
        setTimeout(() => {
          this.listHeight = window.innerHeight - this.buttonBar.nativeElement.offsetHeight + 'px';
        }, 100);
      }
      this.getAllReservations();
    } else if (val === 'timeline') {
      // Set height of scheduler to fit window height and make inner table scrollable
      if (this.schedulerHeight === '') {
        setTimeout(() => {
          this.schedulerHeight =
            window.innerHeight -
            (this.roomTabsGroup._elementRef.nativeElement.offsetHeight +
              this.buttonBar.nativeElement.offsetHeight -
              10);
          setTimeout(() => {
            if (this.scheduler) {
              this.scheduler.instance.repaint();
            }
          }, 100);
        }, 100);
      }

      this.tablesData = this.rooms[0] ? this.rooms[0].tables : [];
      this.selectedRoomId = this.rooms[0] ? this.rooms[0].id : null;
      this.dataSource = new DataSource({
        store: new CustomStore({
          load: options => this.getTimelineReservations(options),
          update: (key, values) => this.updateReservation(key, values)
        })
      });

      // this.dataSource.reload();
    } else if (val === 'tableplan') {
      if (this.dataSource && Object.keys(this.dataSource).length > 0) {
        setTimeout(async () => {
          await this.getAllReservations();
        }, 100);
      } else {
        this.dataSource = new DataSource({
          store: new CustomStore({
            load: () => this.getAllReservations(),
            update: (key, values) => this.updateReservation(key, values)
          })
        });
      }
      // this.dataSource = new DataSource({
      //   store: new CustomStore({
      //     load: () => this.getAllReservations(),
      //     update: (key, values) => this.updateReservation(key, values)
      //   })
      // });
    }
  }

  timelineReservations: any[] = [];

  getTimelineReservations(options: any) {
    options.roomId = this.selectedRoomId;
    this.setTimelineLoading(true);
    return this.reservationService
      .getTimelineReservations(options)
      .toPromise()
      .then((data: any) => {
        data = this.setStatusInfo('timeline', data);
        this.timelineReservations = data || [];
        this.setTimelineLoading(false);
        return data;
      })
      .catch((err: any) => {
        this.setTimelineLoading(false);
        throw err;
      });
  }

  // Keep the component flag and a body-level class in sync. The body class
  // is used by CSS to suppress DevExtreme's detached dx-loadpanel overlay
  // (which renders at the document root, not inside this component) so only
  // our full-view loader is visible during a timeline fetch.
  private setTimelineLoading(loading: boolean) {
    this.loadingTimeline = loading;
    if (typeof document !== 'undefined' && document.body) {
      document.body.classList.toggle('timeline-loading', loading);
    }
  }

  updateReservation(key: any, values: any) {
    if (key.tableId !== values.tableId) {
      // move reservation to other table
      values.startDate = key.startDate;
      values.reservedFor = key.reservedFor;
      values.endDate = key.endDate;
      const minutes = differenceInMinutes(values.endDate, values.startDate);
      values.stayTime = minutes;
      values.oldTableId = key.tableId;
      console.log(480, 'new table', key, values);
    } else {
      // move reservation on the same table
      // values.reservedFor = values.startDate;
      values.reservedFor = key.reservedFor;
      const minutes = differenceInMinutes(values.endDate, values.startDate);
      values.stayTime = minutes;
      values.oldTableId = key.tableId;
      console.log(480, 'same table', key, values);
    }

    return this.reservationService
      .editReservation(values)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  getRooms() {
    return this.reservationService
      .getRooms(false)
      .toPromise()
      .then((data: any) => {
        if (data) {
          this.rooms = data;
          this.tablesData = this.rooms && this.rooms.length ? this.rooms[0].tables : [];
          let allTables: any = [];
          this.rooms.map((item: any) => {
            allTables.push(...item.tables);
          });
          let allRooms = { ...this.rooms[0] };
          allRooms.id = 1000;
          allRooms.name = 'All';
          allRooms.tables = allTables;
          this.rooms.push(allRooms);
        }
      });
  }

  getShifts() {
    this.reservationService
      .getShifts()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((shifts: any) => {
        this.shifts = shifts;
      });
  }

  async selectedTabChange(e: any) {
    const room = this.rooms[e.index];
    if (!room) {
      return;
    }
    this.tab = e.index;
    this.tablesData = room.tables;
    // Skip reload when the room didn't actually change. mat-tab-group fires
    // selectedTabChange on initial render with index 0 while changeView() has
    // already set selectedRoomId + created a fresh DataSource — without this
    // guard the scheduler fires the timeline API twice on every view switch.
    if (this.selectedRoomId === room.id) {
      return;
    }
    this.selectedRoomId = room.id;
    if (this.dataSource && typeof this.dataSource.reload === 'function') {
      this.dataSource.reload();
    }
  }

  onInitialized(e: any) {
    setTimeout(() => {
      const scroll = e.component.getWorkSpaceScrollable();
      const scrollInstance = scroll.instance();
      scrollInstance.beginUpdate();
      scrollInstance.option('useNative', false);
      scrollInstance.endUpdate();

      const currentTimeHour = +moment(new Date()).format('HH') - 2;
      if (this.scheduler) {
        this.scheduler.instance.scrollToTime(currentTimeHour, 0);
      }
    });
  }

  onContentReady(e: any) {
    const scroll = e.component.getWorkSpaceScrollable();
    const scrollInstance = scroll.instance();
    scrollInstance.beginUpdate();
    scrollInstance.option('useNative', false);
    scrollInstance.endUpdate();
  }

  onAppointmentRendered(e: any) {
    const el: HTMLElement = e.appointmentElement;
    const apptData = e.appointmentData;

    if (!apptData) return;

    const tableId = apptData.tableId;
    const start = new Date(apptData.startDate).getTime();
    const end = new Date(apptData.endDate).getTime();

    // Use the cached timeline data (same source as the scheduler) to count
    // how many reservations for the same table overlap this appointment's time.
    const overlappingCount = this.timelineReservations.filter((r: any) => {
      if (r.tableId !== tableId) return false;
      const rStart = new Date(r.startDate).getTime();
      const rEnd = new Date(r.endDate).getTime();
      return start < rEnd && end > rStart;
    }).length;

    if (overlappingCount > 1) {
      el.classList.add('is-compact');
    } else {
      el.classList.remove('is-compact');
    }
  }

  onAppointmentUpdating(e: any) {
    if (e.oldData.locked) {
      e.cancel = true;
      this.snackBar.open('Reservierung ist gesperrt', '', {
        duration: 2000,
        panelClass: ['snackbar-error']
      });
    }
  }

  onCellContextMenu(e: any) {
    this.contextMenuCellData = e.cellData;
    // Get start and end time of all selected cells
    this.contextMenuCellData.startDate = this.scheduler.selectedCellData[0].startDate;
    this.contextMenuCellData.endDate = this.scheduler.selectedCellData[
      this.scheduler.selectedCellData.length - 1
    ].endDate;
  }

  onAppointmentContextMenu(e: any) {
    this.contextMenuAppointmentData = e.appointmentData;
    this.contextMenuTargetedAppointmentData = e.targetedAppointmentData;

    this.onReservationContextMenuShowing(e);
  }

  // Called before the context menu for a reservation is opened
  // so build the menu based on the status
  onReservationContextMenuShowing(e: any) {
    const basicMenuItems: any = [
      {
        text: 'Bearbeiten',
        onItemClick: () => this.editReservation(this.contextMenuTargetedAppointmentData)
      }
    ];
    let contextMenuItems: any = [];
    let roomsContextMenu: any = [];

    const allStatus = this.allStatus.slice(1);

    const confirmedStatus = allStatus.find(status => status.value === 'confirmed');
    const arrivedStatus = allStatus.find(status => status.value === 'arrived');
    const placedStatus = allStatus.find(status => status.value === 'placed');
    const noShowStatus = allStatus.find(status => status.value === 'noShow');
    const canceledStatus = allStatus.find(status => status.value === 'canceled');
    const finishedStatus = allStatus.find(status => status.value === 'finished');

    if (e.appointmentData) {
      if (e.appointmentData.status === 'confirmed') {
        contextMenuItems = [
          { text: 'Status ändern', beginGroup: true, disabled: true },
          {
            ...arrivedStatus,
            text: arrivedStatus.label,
            onItemClick: () => this.updateStatusTimeline('arrived', this.contextMenuTargetedAppointmentData.id)
          },
          {
            ...placedStatus,
            text: placedStatus.label,
            onItemClick: () => this.updateStatusTimeline('placed', this.contextMenuTargetedAppointmentData.id)
          },
          {
            ...finishedStatus,
            text: finishedStatus.label,
            onItemClick: () => this.updateStatusTimeline('finished', this.contextMenuTargetedAppointmentData.id)
          },
          {
            ...noShowStatus,
            text: noShowStatus.label,
            onItemClick: () => this.updateStatusTimeline('noShow', this.contextMenuTargetedAppointmentData.id)
          },
          {
            ...canceledStatus,
            text: canceledStatus.label,
            onItemClick: () => this.updateStatusTimeline('canceled', this.contextMenuTargetedAppointmentData.id)
          }
        ];
      }

      if (e.appointmentData.status === 'pending') {
        contextMenuItems = [
          { text: 'Status ändern', beginGroup: true, disabled: true },
          {
            ...confirmedStatus,
            text: confirmedStatus.label,
            onItemClick: () => this.updateStatusTimeline('confirmed', this.contextMenuTargetedAppointmentData.id)
          },
          {
            ...canceledStatus,
            text: canceledStatus.label,
            onItemClick: () => this.updateStatusTimeline('canceled', this.contextMenuTargetedAppointmentData.id)
          }
        ];
      }

      if (e.appointmentData.status === 'placed') {
        contextMenuItems = [
          { text: 'Status ändern', beginGroup: true, disabled: true },
          {
            ...finishedStatus,
            text: finishedStatus.label,
            onItemClick: () => this.updateStatusTimeline('finished', this.contextMenuTargetedAppointmentData.id)
          }
        ];
      }

      if (!contextMenuItems.length) {
        contextMenuItems = [
          { text: 'Status ändern', beginGroup: true, disabled: true },
          ...allStatus.map(status => ({
            text: status.label,
            color: status.color,
            icon: status.icon,
            onItemClick: () => this.updateStatusTimeline(status.value, this.contextMenuTargetedAppointmentData.id)
          }))
        ];
      } else {
        contextMenuItems = [
          ...contextMenuItems,
          ...this.resStatusList.map(status => ({
            text: status.label,
            color: status.color,
            icon: status.icon,
            onItemClick: () => this.updateStatusTimeline(status.value, this.contextMenuTargetedAppointmentData.id)
          }))
        ];
      }

      if (e.appointmentData.paymentTransaction) {
        contextMenuItems.map((item: any, key: any) => {
          if (item.text == 'Storniert') {
            contextMenuItems.splice(key, 1);
          }
        });
      }

      if (this.rooms.length > 1) {
        roomsContextMenu = [
          {
            text: 'Verschieben...',
            beginGroup: true,
            items: []
          }
        ];

        for (let index = 0; index < this.rooms.length; index++) {
          const room = this.rooms[index];
          roomsContextMenu[0].items.push({
            text: room.name,
            items: this.roomTablesContextMenu(index, this.contextMenuTargetedAppointmentData)
          });
        }
      }
    }

    // Merge arrays
    this.reservationMenu.instance.option('items', [...basicMenuItems, ...contextMenuItems, ...roomsContextMenu]);
  }

  roomTablesContextMenu(roomIndex: number, reservation: any) {
    const tablesContextMenu: any = [];
    for (let index = 0; index < this.rooms[roomIndex].tables.length; index++) {
      const table = this.rooms[roomIndex].tables[index];
      tablesContextMenu.push({
        text: table.name,
        onItemClick: () => {
          const values = reservation;
          if (values.tables && values.tables.length > 1) {
            values.isTablePlan = values.isTablePlan.replace(values.tableId, table.id);
            const replaceTableIndex = values.tables.findIndex((s: any) => s.id === values.tableId);
            values.tables.splice(replaceTableIndex, 1);
            values.tables.push(table);
            values.tableId = table.id;
          } else {
            values.tableId = table.id;
            values.isTablePlan = table.id;
            values.tables = [table];
          }
          return this.reservationService
            .editReservation(values)
            .toPromise()
            .then((data: any) => {
              return data;
            });
        }
      });
    }

    return tablesContextMenu;
  }

  onContextMenuItemClick(e: any) {
    e.itemData.onItemClick(e.itemData);
  }

  getTranslateXY(obj: any) {
    const style = obj.style,
      transform = style.transform || style.webkitTransform;
    const match = transform.match(/translate\((-?\d+(?: \.\d*)?)px, (-?\d+(?:\.\d*)?)px\)/);

    if (!match) {
      return;
    }

    const transObj = {
      x: parseFloat(match[1]),
      y: parseFloat(match[2])
    };
    return transObj;
  }

  openFullscreen() {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    // if (isSafari) {
    this.fakeFullscreen();
    // } else {
    //   (screenfull as Screenfull).request(this.fullscreenEl.nativeElement);
    //   screen.orientation.lock('landscape');
    // }
    /*
    console.log('fs', this.fullscreenEl);
    this.fullscreenEl.nativeElement.requestFullscreen();
    */
  }

  openCreateBottomSheet() {
    const bottomSheetRef = this.bottomSheet.open(AddBottomSheetComponent);
    bottomSheetRef
      .afterDismissed()
      .takeUntil(this.ngUnsubscribe)
      .subscribe(data => {
        if (data && data === 'reservation') {
          this.addReservation();
        } else if (data && data === 'walkin') {
          this.addReservation(true);
        }
      });
  }

  closeFullscreen() {
    if (this.isFakeFullscreen) {
      this.isFullscreen = false;
      this.isFakeFullscreen = false;
      this.navService.showToolbar$.next(true);
      this.schedulerHeight = '';
      this.listHeight = 'auto';
      if (this.scheduler) {
        this.scheduler.instance.repaint();
      }
    } else {
      (screenfull as Screenfull).exit();
    }
  }

  fakeFullscreen() {
    this.navService.appDrawer.close();
    this.navService.showToolbar$.next(false);
    this.isFakeFullscreen = true;
    this.isFullscreen = true;

    // Set height of scheduler to fit window height and make inner table scrollable
    if (this.view === 'timeline') {
      setTimeout(() => {
        // Set scheduler height
        this.schedulerHeight =
          window.innerHeight -
          (this.roomTabsGroup._elementRef.nativeElement.offsetHeight + this.buttonBar.nativeElement.offsetHeight - 10);
        setTimeout(() => {
          this.scheduler.instance.repaint();
        }, 100);
      }, 50);
    } else {
      // Set list height
      setTimeout(() => {
        this.listHeight = window.innerHeight - this.buttonBar.nativeElement.offsetHeight - 15 + 'px';
        // this.table.recalculate();
      }, 50);
    }
  }

  translateStatus(status: string) {
    switch (status) {
      case 'confirmed':
        return 'Bestätigt';
        break;
      case 'canceled':
        return 'Storniert';
        break;
      case 'noShow':
        return 'No Show';
        break;
      case 'arrived':
        return 'Angekommen';
        break;
      case 'placed':
        return 'Platziert';
        break;
      case 'pending':
        return 'Ausstehend';
        break;
      case 'waiting':
        return 'Warteliste';
        break;
      case 'finished':
        return 'Fertig';
        break;
      case 'blocked':
        return 'Ausstehende Zahlung';
        break;
      default:
        break;
    }
  }

  isIntermediateTime(time: string) {
    const array = time.split(':');

    if (array[1] === '15' || array[1] === '30' || array[1] === '45') {
      return true;
    }

    return;
  }

  isIntermediateDate(date: any) {
    const dateString = new Date(date);

    if (dateString.getMinutes() === 0) {
      return;
    }

    return true;
  }

  onAppointmentClick(event: any) {
    event.cancel = true;
    let appendContainer = 'body';
    if (this.isFullscreen) {
      appendContainer = 'dx-scheduler';
    }
    const modalComponent =
      this.activeClient.id == Constants.BVClient ? BVAddReservationComponent : AddReservationComponent;
    const modalRef = this.modalService.open(modalComponent, {
      size: 'lg',
      container: appendContainer
    });

    modalRef.componentInstance.reservation = {
      ...event.appointmentData
    };
    modalRef.componentInstance.isWalkIn = !event.appointmentData.gastId ? true : false;
    modalRef.componentInstance.passEntry.takeUntil(this.ngUnsubscribe).subscribe((receivedEntry: any) => {
      if (this.view === 'list') {
        this.getAllReservations();
      } else {
        this.dataSource.reload();
      }
      this.snackBar.open('Reservierung erfolgreich geändert', '', {
        duration: 2000,
        panelClass: ['snackbar-success']
      });
      modalRef.close();
    });
  }

  onCellClick(event: any) {
    if (this.isDoubleClick === 1) {
      this.prevCellData = event.cellData;
    }
    this.isDoubleClick++;
    setTimeout(() => {
      if (this.isDoubleClick === 2) {
        if (
          event.cellData.startDate === this.prevCellData.startDate &&
          event.cellData.endDate === this.prevCellData.endDate
        ) {
          this.addReservation(false, event.cellData.startDate, null, event.cellData.groups.tableId);
        }
      } else if (this.isDoubleClick === 1) {
        // Do nothing
      }
      this.isDoubleClick = 0;
      this.prevCellData = null;
    }, 300);
  }

  editReservation(reservation: Reservation) {
    let appendContainer = 'body';
    if (this.isFullscreen) {
      appendContainer = '.fullscreen-element';
    }
    const modalComponent =
      this.activeClient.id == Constants.BVClient ? BVAddReservationComponent : AddReservationComponent;
    const modalRef = this.modalService.open(modalComponent, {
      size: 'lg',
      container: appendContainer
    });

    modalRef.componentInstance.reservation = reservation;
    modalRef.componentInstance.isWalkIn = !reservation.gastId ? true : false;
    modalRef.componentInstance.passEntry.takeUntil(this.ngUnsubscribe).subscribe((receivedEntry: any) => {
      if (this.view === 'list') {
        this.getAllReservations();
      } else {
        this.dataSource.reload();
      }
      this.snackBar.open('Reservierung erfolgreich geändert', '', {
        duration: 2000,
        panelClass: ['snackbar-success']
      });
      modalRef.close();
    });
  }

  addReservation(
    walkin: boolean = false,
    startDate: any = null,
    endDate: any = null,
    tableId: any = null,
    instantSave: boolean = false
  ) {
    if (instantSave && walkin) {
      // If instantSave is true, add the reservation without showing modal window
      const momentEndDate = moment(endDate);
      const duration = moment.duration(momentEndDate.diff(startDate));

      let stayTime = duration.asMinutes();
      // let time = moment(startDate).format('HH:mm');
      let time = moment().format('HH:mm');

      if (stayTime == this.bookSettings.timeInterval) {
        stayTime = this.bookSettings.defaultStaytime || 120;
      }

      const reservation = {
        // stayTime: duration.asMinutes(),
        stayTime,
        guestCount: 2,
        reservedFor: startDate,
        // time: moment(startDate).format('HH:mm'),
        time,
        status: 'placed',
        isTablePlan: tableId
      };
      this.reservationService
        .addReservation(reservation)
        .takeUntil(this.ngUnsubscribe)
        .subscribe(res => {
          this.dataSource.reload();
          this.snackBar.open('Walk-In erfolgreich erstellt', '', {
            duration: 2000,
            panelClass: ['snackbar-success']
          });
        });
    } else {
      let appendContainer = 'body';
      if (this.isFullscreen) {
        appendContainer = '.fullscreen-element';
      }
      const modalComponent =
        this.activeClient.id == Constants.BVClient ? BVAddReservationComponent : AddReservationComponent;
      const modalRef = this.modalService.open(modalComponent, {
        size: 'lg',
        container: appendContainer
      });

      modalRef.componentInstance.isWalkIn = walkin;
      modalRef.componentInstance.reservations = this.reservations;
      modalRef.componentInstance.defaultDate = walkin ? new Date() : this.currentDate;
      modalRef.componentInstance.defaultTable = tableId;
      modalRef.componentInstance.startDate = startDate;
      modalRef.componentInstance.endDate = endDate;
      let table = this.tablesData.find((s: any) => s.id === tableId);
      if (table) {
        table.isFree = true;
        modalRef.componentInstance.selectedTablePlanTable = table;
      }

      modalRef.componentInstance.passEntry.takeUntil(this.ngUnsubscribe).subscribe((receivedEntry: any) => {
        if (this.view === 'list') {
          this.getAllReservations();
        } else {
          this.dataSource.reload();
        }
        this.snackBar.open('Reservierung erfolgreich erstellt', '', {
          duration: 2000,
          panelClass: ['snackbar-success']
        });
        modalRef.close();
      });
    }
  }

  async getAllReservations() {
    this.loadingReservationList = true;
    this.tags = [];
    this.resetTimeFilter = false;
    await this.reservationService
      .getAllReservationsBook(this.currentDate, this.currentDate, this.page.pageNumber, 24, '', true, this.view)
      .toPromise()
      .then(async (data: any) => {
        if (data) {
          this.isArchive = data.isArchive;
          this.editing = {}; // Reset editing because of new rows
          this.temp = [...data.reservations];
          this.tempRes = this.temp;
          this.pendingCounter = data.pendingCounter;
          this.waitingCounter = data.waitingCounter;
          this.reservations = data.reservations;
          await new Promise<void>(resolve => {
            this.setReservationListValues();
            resolve();
          });
          this.searchReservation();
          this.loadingReservationList = false;
        }
      });

    //  If not tags, add no tags option
    if (!this.tags.length) {
      this.tags = [
        {
          id: null,
          label: 'Keine Tags für diesen Tag',
          disabled: true
        }
      ];
    }
  }

  setReservationListValues() {
    let resAllMenuOrderTags: any = [];
    let resMenuOrderAlert: any = [];
    if (this.reservations.length) {
      this.reservations.forEach((reservation: any) => {
        if (reservation.tags && this.isArchive === false) {
          reservation.tags = reservation.tags.filter(
            (tag: any) => tag.type !== 'res-menu-order' && tag.type !== 'ticket'
          );
          if (reservation.tags.length) {
            reservation.tags.forEach((tag: any) => {
              if (this.tags.findIndex((x: any) => x.id === tag.id) === -1) {
                tag.selected = false;
                this.tags = [...this.tags, tag];
                // this.tags.push(tag);
              }
            });
          }
        }
        if (reservation && reservation.addOns) {
          reservation.addOns = this.getResAddOns(reservation.addOns);
        }
        let resMenuOrderTags: any = [];
        if (
          reservation.status != 'canceled' &&
          reservation.resMenuOrdersItem &&
          Object.keys(reservation.resMenuOrdersItem).length > 0
        ) {
          let i = 1;
          Promise.all(
            reservation.resMenuOrdersItem.map((item: any) => {
              resMenuOrderTags[item.resAnswers.answer] = {
                count:
                  ((resMenuOrderTags[item.resAnswers.answer] && resMenuOrderTags[item.resAnswers.answer]['count']) ||
                    0) + 1,
                color: item.resAnswers.color,
                preOrderName: item.menuOrder && item.menuOrder.name ? item.menuOrder.name : ''
              };
              resAllMenuOrderTags[item.menuOrder.name + ':' + item.resAnswers.answer] =
                (resAllMenuOrderTags[item.menuOrder.name + ':' + item.resAnswers.answer] || 0) + 1;
            })
          );
          Object.keys(resMenuOrderTags).map((item: any) => {
            reservation.tags.push({
              id: null,
              label: `${resMenuOrderTags[item]['count']} * ${item}`,
              color: resMenuOrderTags[item]['color'] ? resMenuOrderTags[item]['color'] : '#ffb6c1',
              type: 'res-menu-order'
            });
          });
        }
        if (
          (reservation.ticketOrder && Object.keys(reservation.ticketOrder).length > 0) ||
          (reservation.tickets && Object.keys(reservation.tickets).length > 0)
        ) {
          const ticketCategories: any = {};
          const allTickets = reservation.ticketOrder ? reservation.ticketOrder.tickets : reservation.tickets;
          allTickets.forEach((ticket: any) => {
            const ticketName = ticket.ticket.name;
            const subCategoryName = ticket.subCategory.name;

            if (!ticketCategories[ticketName]) {
              ticketCategories[ticketName] = {};
            }

            ticketCategories[ticketName][subCategoryName] = (ticketCategories[ticketName][subCategoryName] || 0) + 1;
          });

          const formattedTickets = Object.entries(ticketCategories).map(([ticketName, subCategoryCounts]) => {
            const formattedCategories = Object.entries(subCategoryCounts)
              .map(([name, count]) => `${count}*${name}`)
              .join(', ');
            return `${ticketName}: ${formattedCategories}`;
          });
          reservation.tags.push({
            id: null,
            label: formattedTickets,
            color: '#f3d425',
            textColor: '#454545',
            type: 'ticket'
          });
        }
        if (reservation.hotelReservation) {
          let roomNoAll: any[] = [];
          if (reservation.hotelReservation.roomNo) {
            roomNoAll.push(reservation.hotelReservation.roomNo);
          }
          if (
            reservation.hotelReservation.attachedReservations &&
            reservation.hotelReservation.attachedReservations.length
          ) {
            reservation.hotelReservation.attachedReservations.forEach((item: any) => {
              if (item.roomNo) {
                roomNoAll.push(item.roomNo);
              }
            });
          }
          reservation.hotelReservation.roomNoAll = roomNoAll.length
            ? roomNoAll
                .sort((a: any, b: any) => Number(a) - Number(b)) // ASC sort
                .join(', ')
            : '';
        }
        if (reservation.hotelReservation && reservation.hotelReservation.reservation) {
          reservation.hotelMealTypeInfo = this.categorizeReservations(
            reservation.hotelReservation.reservation,
            reservation.reservedFor
          );
        }

        if (reservation.tables && reservation.tables.length) {
          reservation.tables.sort((a: any, b: any) => {
            return a.name.localeCompare(b.name, undefined, {
              numeric: true,
              sensitivity: 'base'
            });
          });
        }
      });
    }

    Object.keys(resAllMenuOrderTags).map((item: any) => {
      let preOrderName = item.split(':');
      if (!resMenuOrderAlert[preOrderName[0]]) {
        resMenuOrderAlert[preOrderName[0]] = [];
      }
      resMenuOrderAlert[preOrderName[0]].push(`${resAllMenuOrderTags[item]} * ${preOrderName[1]}`);
    });
    this.resMenuOrderAlert = [];
    if (resMenuOrderAlert && Object.keys(resMenuOrderAlert).length > 0) {
      Object.keys(resMenuOrderAlert).map((item: any) => {
        this.resMenuOrderAlert.push({ info: `${item} : ${resMenuOrderAlert[item].join(', ')}` });
      });
    }
    return true;
  }

  // getIntolerance(intolerance: string): string {
  //   const intolerances = JSON.parse(intolerance);
  //   let result: any = [];
  //   for (let i = 0; i < intolerances.length; i++) {
  //     const element = intolerances[i];
  //     const intoleranceRes = this.intolerance.find(el => {
  //       return element == el.id;
  //     });
  //     result.push(intoleranceRes.name);
  //   }
  //   return result;
  // }

  getResAddOns(addOnsString: string): string {
    const addOns = addOnsString.split(',');
    let result: any = [];
    for (let i = 0; i < addOns.length; i++) {
      const element = addOns[i];
      const addOnsRes = this.resAddOns.find(el => {
        return element == el.id;
      });
      if (addOnsRes && addOnsRes.title) {
        result.push(addOnsRes.title);
      }
    }
    return result;
  }

  prevDay() {
    this.currentDate = subDays(this.currentDate, 1);
    this.changeDate();
  }

  nextDay() {
    this.currentDate = addDays(this.currentDate, 1);
    this.changeDate();
  }

  today() {
    this.currentDate = new Date();
    this.changeDate();
    this.resetTimeFilter = true;
  }

  changeDate() {
    this.getAlerts();
    this.getAllReservations();
  }

  onReservationListChange(event: any) {}

  reservationsChange(e: any[]) {
    e.forEach(newItem => {
      const index = this.temp.findIndex((item: any) => item.id === newItem.id);
      if (index !== -1) {
        this.temp[index] = newItem;
        console.log(`Updated item with id ${newItem.id}`);
      } else {
        console.log(`No match found for id ${newItem.id}`);
      }
    });
  }

  searchReservation(filterObject: any = { isFilterWithTime: false }) {
    // filter our data
    const filterKeys = Object.keys(this.filter);
    const temp = this.temp.filter((eachObj: any) => {
      return filterKeys.every(eachKey => {
        const that = this;
        if (!that.filter[eachKey] || !that.filter[eachKey].toString().length) {
          if (
            (eachObj.status == 'blocked' && that.filter['status'] !== 'blocked') ||
            (!this.bookSettings.showCanceledRes && eachObj.status == 'canceled' && that.filter['status'] !== 'canceled')
          ) {
            return false;
          }
          return true; // passing an empty filter means that filter is ignored.
        }
        // Search for guest name
        if (eachKey === 'name') {
          if (!eachObj.guestData) {
            return false;
          }
          const needle = that.filter[eachKey].toLowerCase();
          const fieldMatches = ['name', 'firstName', 'company', 'email'].some((f: string) => {
            const val = eachObj.guestData[f];
            return val ? val.toLowerCase().includes(needle) : false;
          });
          if (fieldMatches) return true;
          if (this.activeClient.id == Constants.BVClient) {
            return eachObj.bavarianData && eachObj.bavarianData.orderId
              ? eachObj.bavarianData.orderId.toString().includes(that.filter[eachKey])
              : false;
          }
          return eachObj.id ? eachObj.id.toString().includes(that.filter[eachKey].replace('#', '')) : false;
        }
        // Search for room
        if (eachKey === 'roomId') {
          const filterIds = (that.filter[eachKey] || []).map((v: any) => Number(v));
          if (eachObj.tables && eachObj.tables.length) {
            return eachObj.tables.some((x: any) => filterIds.includes(Number(x.roomId)));
          }
          if (eachObj.room) {
            const rooms = Array.isArray(eachObj.room) ? eachObj.room : [eachObj.room];
            return rooms.some((x: any) => x && filterIds.includes(Number(x.id)));
          }
          return false;
        }
        // Search for tags
        if (eachKey === 'tags') {
          if (!eachObj[eachKey] || !eachObj[eachKey].length) {
            return false;
          }
          const candidateIds = (entry: any): number[] => {
            if (entry == null) return [];
            if (typeof entry !== 'object') return [Number(entry)];
            const ids: number[] = [];
            if (entry.tag && entry.tag.id != null) ids.push(Number(entry.tag.id));
            if (entry.tagId != null) ids.push(Number(entry.tagId));
            if (entry.id != null) ids.push(Number(entry.id));
            return ids.filter((n: number) => !Number.isNaN(n));
          };
          return eachObj[eachKey].some((entry: any) => {
            const reservationTagIds = candidateIds(entry);
            return that.filter[eachKey].some((e: any) => {
              const filterTagId = Number(e && typeof e === 'object' ? e.id : e);
              if (Number.isNaN(filterTagId)) return false;
              return reservationTagIds.includes(filterTagId);
            });
          });
        }

        // Search for guest type / meal (hotel vs external)
        if (eachKey === 'gast') {
          const isHotelGuest = !!eachObj.resHotelID;
          if (that.filter[eachKey] === 'external') {
            return !isHotelGuest;
          }
          if (that.filter[eachKey] === 'hotel_all') {
            return isHotelGuest;
          }
          // Meal-specific filter: 'FR' | 'HP' | 'VP'
          return isHotelGuest && eachObj.hotelReservation && eachObj.hotelReservation.board === that.filter[eachKey];
        }

        // Search for status
        if (eachKey === 'status') {
          if (that.filter[eachKey] === 'active') {
            return ['confirmed', 'arrived', 'placed'].includes(eachObj[eachKey]);
          }
          return that.filter[eachKey] === eachObj[eachKey];
        }
        // Search for shifts
        if (eachKey === 'shiftId') {
          if (!eachObj[eachKey]) return false;
          return Number(eachObj[eachKey]) === Number(that.filter[eachKey]);
        }
        return that.filter[eachKey].includes(eachObj[eachKey]);
      });
    });
    // update the rows
    this.reservations = temp;
    this.tempRes = temp;
    const { repaint, isFilterWithTime = false } = filterObject;
    if (isFilterWithTime) {
      this.filterReservationWithTime(repaint);
    } else {
      this.filterReservationWithTime();
    }
    // Whenever the filter changes, always go back to the first page
    // this.table.offset = 0;
  }

  getAllTags() {
    this.reservationService
      .getTags()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((tags: any) => {
        this.allTags = tags;
      });
  }

  updateValue(event: any, cell: any, rowIndex: number, reservationId: number) {
    this.editing[rowIndex + '-' + cell] = false;
    this.reservations[rowIndex][cell] = event.target.value;
    this.reservations = [...this.reservations];
    const index = this.reservations.findIndex((x: any) => x.id === reservationId);
    this.reservationService
      .editReservation(this.reservations[index])
      .takeUntil(this.ngUnsubscribe)
      .subscribe(() => {});
  }

  updateStatusTimeline(status: string, reservationId: number) {
    if (this.bookSettings.confirmStatusChange) {
      const modalRef = this.modalService.open(ConfirmModalComponent);
      modalRef.componentInstance.title = 'Status ändern';
      modalRef.componentInstance.message = `Sind Sie sicher dass Sie den Status auf "${this.translateStatus(
        status
      )}" setzen möchten?`;
      modalRef.componentInstance.showInfo = false;
      modalRef.componentInstance.buttonText = 'Ja';

      modalRef.result.then(
        (result: any) => {
          if (result === 'ok') {
            this.updateStatusTimelineHelper(status, reservationId);
          }
        },
        () => {}
      );
    } else {
      this.updateStatusTimelineHelper(status, reservationId);
    }
  }

  async updateStatusTimelineHelper(status: string, reservationId: number) {
    const index = await this.dataSource._items.findIndex((x: any) => x.id === reservationId);
    const reservData: any = { ...this.dataSource._items[index] };
    reservData.status = status;
    if (reservData.guestData) {
      reservData.guestData.guestInform = true;
    }
    reservData.guestCount = reservData.peopleCount;
    this.reservationService
      .editReservation(reservData)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(
        () => {
          this.dataSource.reload();
          this.snackBar.open('Status wurde erfolgreich geändert', '', {
            duration: 2000,
            panelClass: ['snackbar-success']
          });
        },
        err => {
          this.snackBar.open(`Status konnte nicht geändert werden (${err.error.msg})`, '', {
            duration: 2000,
            panelClass: ['snackbar-error']
          });
        }
      );
  }

  isToday() {
    return isSameDay(new Date(), this.currentDate);
  }

  async reservationsFiltered(e: any) {
    this.filteredReservations = e;
  }

  downloadPdf() {
    const doc = new jsPDF('p', 'mm', 'a4');
    const isGerman = this.activeClientSettings === 'de';
    const t = (en: string, de: string) => (isGerman ? de : en);

    let reservations: any = [];
    this.reservations.map((item: any) => {
      if (this.filteredReservations.includes(item.id)) {
        reservations.push(item);
      }
    });

    const reservationsArray = JSON.parse(JSON.stringify(reservations));
    const parsedReservations = reservationsArray
      .filter((res: any) => res.status !== 'canceled')
      .map((res: any) => {
        const details: string[] = [];
        //
        if (this.pdfSetting.showEndTime) {
          res.reservedFor = moment(res.reservedFor).format('HH:mm') + ' - ' + moment(res.endDate).format('HH:mm'); // + ' Uhr';
        } else {
          res.reservedFor = moment(res.reservedFor).format('HH:mm');
        }

        if (res.guestData && typeof res.guestData === 'object') {
          let guestName = res.guestData.company
            ? `${res.guestData.company} (${res.guestData.name || ''})`
            : res.guestData.name || '';

          if (!res.guestData.company && res.guestData.firstName) {
            guestName += guestName ? `, ${res.guestData.firstName}` : res.guestData.firstName;
          }

          res.guestName = guestName;
        } else {
          res.guestName = t('Walk-In', 'Walk-In');
        }

        const notes: string[] = [];
        if (this.pdfSetting.showAdminNotes && res.notes) {
          const cleanNotes = res.notes.replace(/\r?\n|\r/g, ' ').trim();
          notes.push(t('Admin Note:', 'Admin-Hinweis:') + ' ' + cleanNotes);
        }
        // if (this.pdfSetting.showGuestNotes && res.msg) {
        //   const cleanMsg = res.msg.replace(/\r?\n|\r/g, ' ').trim();
        //   notes.push(t('Guest Note:', 'Gast-Hinweis:') + ' ' + cleanMsg);
        // }
        if (this.pdfSetting.showGuestNotes && (res.msg || res.customerNotes)) {
          const parts: string[] = [];
          if (res.msg) {
            parts.push(res.msg.replace(/\r?\n|\r/g, ' ').trim());
          }
          if (res.customerNotes) {
            parts.push(res.customerNotes.replace(/\r?\n|\r/g, ' ').trim());
          }
          notes.push(t('Guest Note:', 'Gast-Hinweis:') + ' ' + parts.join(' | '));
        }

        res.guestName = `**${res.guestName}**`;
        if (notes.length) {
          res.guestName += `\n${notes.map(n => '\x0F' + n).join('\n')}`;
        }

        if (res.hotelReservation) {
          if (this.pdfSetting.showRoomNumber && res.hotelReservation.roomNoAll) {
            details.push(`${t('Room No', 'Zimmer-Nr')}: ${res.hotelReservation.roomNoAll}`);
          }
          if (this.pdfSetting.showArrivingDate && res.hotelReservation.arrivalDate) {
            details.push(
              `${t('Arrival date', 'Anreisedatum')}: ${moment(res.hotelReservation.arrivalDate).format('DD.MM.YY')}`
            );
          }
          if (this.pdfSetting.showDepartureDate && res.hotelReservation.departureDate) {
            details.push(
              `${t('Departure date', 'Abreisedatum')}: ${moment(res.hotelReservation.departureDate).format('DD.MM.YY')}`
            );
          }
          if (this.pdfSetting.showBoard && res.hotelReservation.board) {
            details.push(`${t('Board', 'Verpflegung')}: ${res.hotelReservation.board}`);
          }

          if (details.length) {
            res.guestName += `\n\x0F${details.join(' - ')}`;
          }
        }

        const tables: any = [];
        if (res && res.tables && res.tables.length) {
          res.tables.forEach((tableData: any) => {
            tables.push(tableData.name);
          });
        }
        res.tablesString = '';
        let i = 0;
        tables.forEach((t: string, index: number) => {
          res.tablesString += t;
          i++;
          if (i < 4 && index < tables.length - 1) {
            res.tablesString += ',';
          }
          if (i === 4) {
            res.tablesString += '\n';
            i = 0;
          }
        });

        if (!res.tablesString || res.tablesString == '') {
          if (res.room && res.room.name) {
            res.tablesString = res.room.name;
          }
        }

        res.peopleCount = res.peopleCount + ' ';
        if (res.highChairs && res.children) {
          res.peopleCount = res.peopleCount + ` (${t('C', 'K')}: ${res.children}, ${t('HC', 'HS')}: ${res.highChairs})`;
        } else {
          if (res.children) {
            res.peopleCount += `(${t('C', 'K')}: ${res.children})`;
          }
          if (res.highChairs) {
            res.peopleCount += `(${t('HC', 'HS')}: ${res.highChairs})`;
          }
        }

        const tags: any = [];
        if (this.pdfSetting.showTags && res.tags) {
          res.tags.forEach((tagData: any) => {
            tags.push(tagData.label);
          });
        }
        res.tagsString = tags.join(',');
        return res;
      });

    // Header: Top right print time
    const printDate = moment().format('DD.MM.YY') + ' - ' + moment().format('HH:mm');
    doc.setFontSize(8);
    const width = doc.internal.pageSize.getWidth();
    const txtWidth = doc.getTextWidth(printDate);
    doc.text(width - 15 - txtWidth, 10, printDate);

    // Header title
    doc.setFontSize(11);
    // doc.text(15, 10, t('Reservations', 'Reservierungen'));
    doc.text(
      15,
      10,
      t('Reservations for', 'Reservierungen für den') + ' ' + moment(this.currentDate).format('DD.MM.YYYY')
    );
    // Table rendering
    doc.autoTable({
      body: parsedReservations,
      styles: {
        overflow: 'linebreak',
        cellPadding: 2
      },
      headStyles: { fillColor: [0, 0, 0], fontSize: 10 },
      columnStyles: {
        guestName: { cellWidth: 85, minCellHeight: 15 },
        tagsString: { cellWidth: 20 }
      },
      columns: [
        { header: t('Time', 'Uhrzeit'), dataKey: 'reservedFor' },
        { header: t('Name', 'Name'), dataKey: 'guestName' },
        { header: t('Guests', 'Gäste'), dataKey: 'peopleCount' },
        { header: t('Table', 'Tisch'), dataKey: 'tablesString' },
        { header: t('Tags', 'Tags'), dataKey: 'tagsString' }
      ],
      willDrawCell: function(data: any) {
        if (data.column.dataKey === 'guestName' && typeof data.cell.raw === 'string') {
          const doc = data.doc;
          const content = data.cell.raw.split('\n');
          const maxWidth = data.cell.width - 4;
          let totalLines = 0;

          content.forEach((line: string) => {
            const cleaned = line.replace(/\*\*/g, '').replace('\x0F', '');
            const wrapped = doc.splitTextToSize(cleaned, maxWidth);
            totalLines += wrapped.length;
          });

          const lineHeight = 4.5;
          const padding = 3;
          data.row.height = Math.max(data.row.height, totalLines * lineHeight + padding);
        }
      },
      didParseCell: function(data: any) {
        if (data.column.dataKey === 'guestName' && data.cell.text != 'Name') {
          data.cell.text = '';
        }
      },

      didDrawCell: function(data: any) {
        if (data.section === 'body' && data.column.dataKey === 'guestName' && typeof data.cell.raw === 'string') {
          const doc = data.doc;
          const x = data.cell.x + 2;
          const maxWidth = data.cell.width - 4;
          const lines = data.cell.raw.split('\n');
          const lineHeight = 4.5;
          let y = data.cell.y + 5;

          lines.forEach((line: string, index: number) => {
            let fontSize = 10;
            let fontStyle = 'normal';
            let color: [number, number, number] = [0, 0, 0];

            if (index === 0 && line.startsWith('**') && line.endsWith('**')) {
              fontStyle = 'bold';
              line = line.replace(/\*\*/g, '');
            } else if (line.startsWith('\x0F')) {
              fontSize = 9;
              color = [128, 128, 128];
              line = line.replace('\x0F', '');
            }
            const wrapped = doc.splitTextToSize(line, maxWidth);
            doc.setFont(undefined, fontStyle as any);
            doc.setFontSize(fontSize);
            doc.setTextColor(...color);
            doc.text(wrapped, x, y);
            y += wrapped.length * lineHeight;
          });
        }
      }
    });

    doc.save(`${t('Reservations', 'Reservierungen')}_${moment(this.currentDate).format('YYYY-MM-DD')}.pdf`);
  }

  sortTablesComparator(propA: any, propB: any, rowA: any, rowB: any) {
    // do something with rowA and rowB objects.
    if (rowA.tables[0] && rowB.tables[0]) {
      if (rowA.tables[0].name < rowB.tables[0].name) {
        return -1;
      }
      if (rowA.tables[0].name > rowB.tables[0].name) {
        return 1;
      }
    }
    return 0;
  }

  toggleEditMode() {
    this.editMode = !this.editMode;
    if (!this.editMode) {
      this.snackBar.open('Bearbeitungsmodus beendet.', '', {
        duration: 2000,
        panelClass: ['snackbar-success']
      });
      if (this.scheduler) {
        this.scheduler.instance.repaint();
      }
    } else {
      this.snackBar.open('Bearbeitungsmodus gestartet. Sie können nun Reservierungen verschieben.', '', {
        duration: 2000,
        panelClass: ['snackbar-success']
      });
    }
  }

  onRowActivate(event: any) {
    if (event.type === 'click' && event.column.prop !== 'status') {
      this.editReservation(event.row);
    }
  }

  openAllPending(status: any) {
    if (!this.isArchive) {
      let appendContainer = 'body';
      if (this.isFullscreen) {
        appendContainer = '.fullscreen-element';
      }

      const modalRef = this.modalService.open(PendingReservationsComponent, {
        size: 'lg',
        container: appendContainer
      });
      modalRef.componentInstance.statusValue = status;
    }
  }

  fsChanged(event: any) {
    this.reservationService.fsSubject.next(event || 14);
  }

  getResTimeFilter() {
    this.reservationService
      .getResTimeFilter()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((resTimeFilter: any) => {
        if (resTimeFilter && resTimeFilter.length > 0) {
          this.timeFilter = resTimeFilter;
        }
      });
  }

  checkSelectedFilter(name: any) {
    if (this.selectedTimeFilter.includes(name)) {
      return true;
    }
    return false;
  }

  filterReservationWithTime(repaint: boolean = false) {
    const timeFilterValue: any = {};
    let temp = this.tempRes;
    this.reservations = temp;
    const data2: any = [];
    if (this.bookSettings) {
      this.bookSettings.startTime = this.bookSettings.startTimeOriginal;
      this.bookSettings.endTime = this.bookSettings.endTimeOriginal;
    }
    if (this.selectedTimeFilter && this.selectedTimeFilter.length > 0) {
      for (const item of this.selectedTimeFilter) {
        const filterValue = this.timeFilter.find((el: any) => item == el.name);
        if (filterValue) {
          timeFilterValue.from = filterValue.from;
          timeFilterValue.to = filterValue.to;
          if (timeFilterValue.from && timeFilterValue.to) {
            if (this.bookSettings && Object.keys(this.bookSettings).length > 0) {
              this.bookSettings.startTime = parseInt(timeFilterValue.from.split(':')[0], 10);
              this.bookSettings.endTime =
                parseInt(timeFilterValue.to.split(':')[0], 10) < this.bookSettings.startTime
                  ? 24
                  : parseInt(timeFilterValue.to.split(':')[0], 10);
            }
            const startDate = new Date(this.currentDate);
            const endDate = new Date(this.currentDate);
            if (timeFilterValue.from && timeFilterValue.from.length > 0) {
              const [hours, minutes] = timeFilterValue.from.split(':');
              startDate.setHours(parseInt(hours, 10));
              startDate.setMinutes(parseInt(minutes, 10));
              startDate.setSeconds(0);
              startDate.setMilliseconds(0);
            } else {
              startDate.setHours(0, 0, 0, 0);
            }
            if (timeFilterValue.to && timeFilterValue.to.length > 0) {
              const [hours, minutes] = timeFilterValue.to.split(':');
              endDate.setHours(parseInt(hours, 10));
              endDate.setMinutes(parseInt(minutes, 10));
              endDate.setSeconds(0);
              endDate.setMilliseconds(0);
            } else {
              endDate.setHours(0, 0, 0, 0);
            }
            temp.forEach((reservation: any) => {
              const reservedDate2 = new Date(reservation.reservedFor).getTime();
              const startTime = startDate.getTime();
              const endTime = endDate.getTime();
              if (timeFilterValue.to >= timeFilterValue.from) {
                if (reservedDate2 >= startTime && reservedDate2 <= endTime) {
                  data2.push(reservation);
                }
              } else if (reservedDate2 >= startTime && reservedDate2 <= addDays(endDate, 1).getTime()) {
                data2.push(reservation);
              }
            });
          }
        }
      }
      // console.log('final1', data);
      // console.log('final2', data2);
      this.reservations = data2;
    }
    this.reservations = this.setStatusInfo(this.view, this.reservations);
    if (this.view === 'timeline' && repaint) {
      setTimeout(() => {
        this.scheduler.instance.repaint();
      }, 100);
    }
  }

  filterReservationWithTimeWithSearch(timeData: any = '', repaint: boolean = false) {
    const { name = '', status = null, shiftId = null, tagIds = [], roomIds = [] } = timeData;

    if (!name) {
      return;
    }

    if (this.selectedTimeFilter.includes(name)) {
      const indexToDelete = this.selectedTimeFilter.indexOf(name);
      if (indexToDelete !== -1) {
        this.filter = {
          ...this.filter,
          status: null,
          tags: [],
          roomId: [],
          shiftId: null
        };
        this.selectedTimeFilter.splice(indexToDelete, 1);
        this.searchReservation();
      }
      return;
    }

    // accept comma-separated string, array of ids, or legacy array of objects
    const parseIdList = (value: any): number[] => {
      if (value == null || value === '') return [];
      const raw = Array.isArray(value) ? value : String(value).split(',');
      return raw
        .map((v: any) => (v && typeof v === 'object' ? v.id : v))
        .map((v: any) => Number(v))
        .filter((v: number) => !Number.isNaN(v));
    };
    const parsedRoomIds = parseIdList(roomIds);
    const normalizedRoomIds = parsedRoomIds.includes(1000) ? [] : parsedRoomIds;
    const tagIdNumbers = parseIdList(tagIds);
    if (tagIdNumbers.length) {
      const cleanedTags = this.tags.filter((t: any) => t && t.id != null);
      let mutated = cleanedTags.length !== this.tags.length;
      tagIdNumbers.forEach((id: number) => {
        if (!cleanedTags.find((t: any) => Number(t.id) === id)) {
          const fromAllTags = (this.allTags || []).find((t: any) => Number(t.id) === id);
          if (fromAllTags) {
            cleanedTags.push(fromAllTags);
            mutated = true;
          }
        }
      });
      if (mutated) this.tags = [...cleanedTags];
    }
    const normalizedTagObjects = tagIdNumbers
      .map((id: number) => this.tags.find((t: any) => t && Number(t.id) === id))
      .filter((t: any) => !!t);

    this.filter = {
      ...this.filter,
      status: status || null,
      tags: normalizedTagObjects,
      roomId: normalizedRoomIds,
      shiftId: shiftId || null
    };
    this.selectedTimeFilter = [name];
    this.searchReservation({ repaint, isFilterWithTime: true });
  }

  viewExtraFilters() {
    this.showExtraFilters = !this.showExtraFilters;
  }

  setStatusInfo(view: any, reservations: any) {
    reservations = reservations.map((item: any) => {
      let statusInfo: any;
      if (Constants.fixedStatusMap[item.status]) {
        if (view == 'timeline') {
          statusInfo = [];
        } else {
          statusInfo = Constants.fixedStatusMap[item.status];
        }
      } else {
        let customStatus = this.allStatus.find((status: any) => status.value === item.status);
        if (customStatus) {
          statusInfo = customStatus;
        } else {
          statusInfo = { ...Constants.defaultStatus, label: item.status, value: item.status };
        }
      }
      item.displayMsg = [item.msg, item.customerNotes].filter(Boolean).join('\n');
      return { ...item, statusInfo };
    });
    return reservations;
  }

  categorizeReservations(reservations: any[], targetReservedFor: string): any {
    const [targetDate, targetTime] = targetReservedFor.split(' ');
    const targetHour = parseInt(targetTime.split(':')[0], 10);

    // Determine meal type
    let mealType = '';
    if (targetHour < Constants.mealEndTimes.breakfast) {
      mealType = 'breakfast';
    } else if (targetHour >= Constants.mealEndTimes.lunchStart && targetHour < Constants.mealEndTimes.lunchEnd) {
      mealType = 'lunch';
    } else {
      mealType = 'dinner';
    }

    // Filter all reservations matching the target meal type
    const filteredReservations = reservations.filter(reservation => {
      const resHour = parseInt(reservation.reservedFor.split(' ')[1].split(':')[0], 10);
      if (mealType === 'breakfast' && resHour < Constants.mealEndTimes.breakfast) return true;
      if (
        mealType === 'lunch' &&
        resHour >= Constants.mealEndTimes.lunchStart &&
        resHour < Constants.mealEndTimes.lunchEnd
      )
        return true;
      if (mealType === 'dinner' && resHour >= Constants.mealEndTimes.lunchEnd) return true;
      return false;
    });

    // Sort reservations by date & time
    filteredReservations.sort((a, b) => a.reservedFor.localeCompare(b.reservedFor));

    // console.log('Filtered Reservations:', filteredReservations);

    // Find position of target reservation in sorted list
    const mealPosition = filteredReservations.findIndex(res => res.reservedFor === targetReservedFor) + 1;
    const totalMealsOfType = filteredReservations.length;

    if (mealPosition === 0) {
      return {}; // Return empty object for invalid reservation
    }

    // Only first meal gets a color
    let color = '';
    if (mealPosition === 1) {
      color = '#24b314'; // Green for first visit
    }

    return {
      visit: `${mealPosition}/${totalMealsOfType}`,
      ...(color ? { color } : {})
    };
    return `${mealPosition}/${totalMealsOfType}`;
    // return `${mealPosition}/${totalMealsOfType} ${mealType}`;
  }
  formatDisplayName(firstName: string | null, lastName: string | null) {
    const displayNameFormat = this.bookSettings.displayNameFormat;
    return this.utilsService.formatName(firstName, lastName, displayNameFormat);
  }

  // Pure show/hide — no scheduler repaint or data reload. CSS + Angular's
  // layout change on the column class are enough; repainting here triggered
  // the DataSource re-evaluation and the full-view loader flashed.
  toggleTimelineSidebar() {
    this.timelineSidebarOpen = !this.timelineSidebarOpen;
  }

  onSidebarReservationClick(reservation: any) {
    this.isDoubleClick++;
    setTimeout(() => {
      if (this.isDoubleClick === 2) {
        this.editReservation(reservation);
      } else if (this.isDoubleClick === 1) {
        this.onSidebarReservationSelected(reservation);
      }
      this.isDoubleClick = 0;
    }, 300);
  }

  onSidebarReservationSelected(reservation: any) {
    if (!reservation.active) {
      this.reservations.forEach((res: any) => {
        if (res.active) {
          res.active = false;
        }
      });
      reservation.active = true;

      if (this.view !== 'timeline') {
        return;
      }

      // If this reservation's table lives in a different room than the one
      // currently shown, switch to that room tab first. The scheduler reloads
      // asynchronously, so defer the scroll until onContentReady fires.
      const targetRoomIndex = this.findRoomIndexForReservation(reservation);
      const targetRoomId = targetRoomIndex >= 0 ? this.rooms[targetRoomIndex].id : null;
      const needsRoomSwitch =
        targetRoomIndex >= 0 && targetRoomId !== this.selectedRoomId && this.selectedRoomId !== 1000;

      if (needsRoomSwitch) {
        this.tab = targetRoomIndex;
        // Defer scroll until after mat-tab-group switches + dataSource reloads
        // and the scheduler re-renders for the new room. Hooking into DevExtreme's
        // onContentReady caused "_contentReadyAction is not a function" errors,
        // so a timeout-based approach is used instead.
        setTimeout(() => this.scrollSchedulerToReservation(reservation), 600);
      } else {
        this.scrollSchedulerToReservation(reservation);
      }
    } else {
      reservation.active = false;
    }
  }

  // Resolve which room tab (by index in `this.rooms`) a reservation belongs to.
  // Prefers the explicit room id on the reservation's first assigned table.
  // Skips the synthetic "All" room (id 1000) appended by getRooms().
  private findRoomIndexForReservation(reservation: any): number {
    const table = reservation && reservation.tables && reservation.tables.length ? reservation.tables[0] : null;
    const roomId = table && table.roomId != null ? table.roomId : null;
    if (roomId == null) {
      return -1;
    }
    return this.rooms.findIndex((r: any) => r && r.id === roomId && r.id !== 1000);
  }

  private scrollSchedulerToReservation(reservation: any) {
    if (!this.scheduler || !this.scheduler.instance || !reservation || !reservation.startDate) {
      return;
    }
    try {
      const start = new Date(reservation.startDate);
      const hour = Math.max(0, start.getHours() - 1);
      this.scheduler.instance.scrollToTime(hour, 0);
    } catch (err) {
      // Scheduler may be mid-render/destroyed; swallow to avoid surfacing
      // DevExtreme internal errors up through the zone.
      console.warn('[timeline sidebar] scrollToTime failed', err);
    }
  }

  refreshSidebarStatusItems(reservation: any) {
    if (!reservation) {
      return;
    }
    this.sidebarStatusItems.forEach((status: any) => {
      status.isActive = status.value === reservation.status;
    });
  }

  onSidebarStatusItemClick(event: any, reservation: any) {
    const selectedStatus = event.itemData.value;
    if (!selectedStatus || selectedStatus === reservation.status) {
      return;
    }
    this.updateStatusTimeline(selectedStatus, reservation.id);
  }

  getCardStatusColor(reservation: any): string {
    if (reservation && reservation.statusInfo && reservation.statusInfo.color) {
      return reservation.statusInfo.color;
    }
    if (reservation && Constants.fixedStatusMap[reservation.status]) {
      return Constants.fixedStatusMap[reservation.status].color;
    }
    const custom =
      reservation && this.allStatus ? this.allStatus.find((s: any) => s.value === reservation.status) : null;
    return custom ? custom.color : '#bfbbbb';
  }

  getCardStatusLabel(reservation: any): string {
    if (reservation && reservation.statusInfo && reservation.statusInfo.label) {
      return reservation.statusInfo.label;
    }
    if (reservation && Constants.fixedStatusMap[reservation.status]) {
      return Constants.fixedStatusMap[reservation.status].label;
    }
    const custom =
      reservation && this.allStatus ? this.allStatus.find((s: any) => s.value === reservation.status) : null;
    return custom ? custom.label : reservation && reservation.status ? reservation.status : '';
  }

  lightenColor(hex: string, factor = 0.1): string {
    if (!hex) {
      return 'transparent';
    }
    const h = hex.replace('#', '');
    if (h.length !== 6) {
      return 'transparent';
    }
    const r = parseInt(h.substring(0, 2), 16);
    const g = parseInt(h.substring(2, 4), 16);
    const b = parseInt(h.substring(4, 6), 16);
    const lr = Math.round(r * factor + 255 * (1 - factor));
    const lg = Math.round(g * factor + 255 * (1 - factor));
    const lb = Math.round(b * factor + 255 * (1 - factor));
    return `rgb(${lr}, ${lg}, ${lb})`;
  }
}

@Component({
  selector: 'app-add-bottom-sheet',
  template: `
    <mat-nav-list>
      <a href="#" mat-list-item (click)="$event.preventDefault(); addReservation()">
        <span mat-line>Neue Reservierung</span>
        <span mat-line>Erstellen Sie eine Reservierung <b>mit</b> Gastdaten</span>
      </a>
      <a href="#" mat-list-item (click)="$event.preventDefault(); addWalkin()">
        <span mat-line>Neuen Walk-In</span>
        <span mat-line>Erstellen Sie eine Reservierung <b>ohne</b> Gastdaten</span>
      </a>
    </mat-nav-list>
  `
})
export class AddBottomSheetComponent {
  constructor(private bottomSheetRef: MatBottomSheetRef<AddBottomSheetComponent>) {}

  addReservation() {
    this.bottomSheetRef.dismiss('reservation');
  }
  addWalkin() {
    this.bottomSheetRef.dismiss('walkin');
  }
}
